import React from 'react';
import ChordDiagram from 'react-chord-diagram';

import { Stack, Text } from '@mantine/core';

import type { CircosData } from '../generated/generatedOpenAPI';

interface CircosPlotProps {
  circosData: CircosData | undefined;
}

export default function CircosPlot({ circosData }: CircosPlotProps) {
  const groupColors = React.useMemo(() => {
    if (!circosData) {
      return [];
    }
    let kv = 0;
    let lv = 0;
    let hv = 0;
    for (const item of circosData.geneNames) {
      if (item.includes('KV')) {
        kv += 1;
      }
      if (item.includes('LV')) {
        lv += 1;
      }
      if (item.includes('HV')) {
        hv += 1;
      }
    }
    const kvColor: Array<string> = new Array(kv).fill('#54A5EB');
    const lvColor: Array<string> = new Array(lv).fill('#A8D7FF');
    const hvColor: Array<string> = new Array(hv).fill('#206198');
    const colors: Array<string> = [];
    return colors.concat(kvColor, lvColor, hvColor);
  }, [circosData]);

  return (
    <Stack align="center" data-testid="v-gene-circos-plot">
      <Text size="xl"> Circos plot of VH/VL V-gene usage combinations</Text>
      <ChordDiagram
        style={{ padding: 0 }}
        matrix={circosData?.layout}
        componentId={1}
        groupLabels={circosData?.geneNames}
        groupColors={groupColors}
        outerRadius={255}
      />
    </Stack>
  );
}
